﻿module.exports = ['common', 'dataContext', '$q', '$translate', 'applicationStateService', 'notificationsService', countryDataService];

function countryDataService(common, context, $q, $translate, state, notifications) {

    var service = {
        countries: null,
        ergaOmnesCountries: null,
        regions: null, // list of country codes per region
        getCountry: getCountry,
        getCountries: getCountries,
        preloadCountries: preloadCountries,
        getEuCountries: getEuCountries,
        preloadRegions: preloadRegions,
        transformCountriesForCountryPicker: transformCountriesForCountryPicker,
        init: init
    };

    notifications.subscribe('filter_date_changed', init);

    return service;

    function init() {
        return $q.all([ preloadCountries(), preloadRegions() ])
            .then(function() {
                return initErgaOmnesCountries()
            });
    }

    function getErgaOmnesRegionCode(referenceCountry) {
        if (referenceCountry === 'CH') {
            return '200000';
        }
        else if (referenceCountry === 'US') {
            return 'ALL';
        }
        else if (referenceCountry === 'FR') {
            // NB: technically, this is not erga omnes (it includes EU member states and French overseas regions).
            // However, this is the code of the region that contains the countries which are available in the country filter dropdown
            // in the French trade tariff.
            return 'FR01';
        }
        return '1011';
    }

    function initErgaOmnesCountries() {
        var referenceCountry = state.filter.referenceCountry;
        var ergaOmnesRegionCode = getErgaOmnesRegionCode(referenceCountry);
        service.ergaOmnesCountries = _.chain(service.regions[ergaOmnesRegionCode])
            .map(function(countryCode) {
                return {
                    code: countryCode,
                    name: service.countries[countryCode],
                    searchDisplay: countryCode + ' — ' + service.countries[countryCode]
                };
            }).filter(function(country) {
                return country.name !== undefined && (country.code === 'EU' || country.code !== referenceCountry);
            }).sortBy(function(country) {
                return country.name;
            }).value();
    }

    // to be used with the results of the getCountries function
    function transformCountriesForCountryPicker(countries) {
        return countries.map(country => ({
                code: country.code,
                name: country.name,
                searchDisplay: country.code + ' — ' + country.name
            }));
    }

    function getCountry(countryCode) {
        if (countryCode === null || countryCode === undefined)
            return countryCode;
        if (service.countries === null)
            service.preloadCountries();
        return service.countries[countryCode];
    }

    function getEuCountries(q) {
        if (state.filter.referenceCountry == 'CH') {
            q.regionCode = '100001';
        }
        else {
            q.regionCode = '1010';
        }
        return getCountries(q);
    }

    function getCountries(q) {
        var url = common.config.apiHosts[common.config.currentApi] + '/countries' +
            '?referenceCountry=' + (q.referenceCountry || state.filter.referenceCountry) +
            '&lang=' + common.language.get() +
            '&date=' + state.filter.date;
        if (q.regionCode) {
            url += '&region=' + q.regionCode;
        }
        return context.get(url);
    }

    function preloadCountries(regionCode) {
        var qCountriesLoaded = common.$q.defer();
        var url = common.config.apiHosts[common.config.currentApi] + '/countries' +
            '?referenceCountry=' + state.filter.referenceCountry +
            '&lang=' + common.language.get() +
            '&date=' + state.filter.date;
        if (regionCode) {
            url += '&region=' + regionCode;
        }
        context.get(url).then(function (data) {
            service.countries = {};
            _.forEach(data, function (country) {
                if (!service.countries[country.code]) {
                    service.countries[country.code] = country.name;
                }
            });
            qCountriesLoaded.resolve();
        }, function (error) {
            qCountriesLoaded.reject(error);
        });

        return qCountriesLoaded.promise;
    }

    function preloadRegions() {
        var qRegionsLoaded = common.$q.defer();

        // TODO: update this to be ready for the situation after Brexit so the UK version doesn't automatically get all EU regions
        var url = common.config.apiHosts[common.config.currentApi] + '/regions/members' +
            '?origin=EU,' + state.filter.referenceCountry +
            '&referenceCountry=' + state.filter.referenceCountry +
            '&date=' + state.filter.date;
        context.get(url).then(function (data) {
            service.regions = {};
            _.forEach(data, function (region) {
                if (!service.regions[region.code]) {
                    service.regions[region.code] = region.countryCodes;
                }
            });
            qRegionsLoaded.resolve();
        }, function(error) {
            qRegionsLoaded.reject(error);
        });

        return qRegionsLoaded.promise;
    }
}
